import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { AIPattern } from './components/AIPattern';
import { GoogleAnalytics } from './components/GoogleAnalytics';
import { CookieConsent } from './components/CookieConsent';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Philosophy } from './pages/Philosophy';
import { Solutions } from './pages/Solutions';
import { TechnologyApproach } from './pages/TechnologyApproach';
import { EthicsGovernance } from './pages/EthicsGovernance';
import { Insights } from './pages/Insights';
import { Contact } from './pages/Contact';
import { Privacy } from './pages/Privacy';
import { ScrollToTop } from './components/ScrollToTop';
// Replace with your actual Google Analytics Measurement ID
const GA_MEASUREMENT_ID = 'G-XXXXXXXXXX';
export function App() {
  return <Router data-id="element-0">
      <LanguageProvider data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <GoogleAnalytics measurementId={GA_MEASUREMENT_ID} data-id="element-3" />
        <div className="min-h-screen bg-carbon text-ivory font-sans selection:bg-ai-teal/30 selection:text-ai-teal" data-id="element-4">
          <AIPattern data-id="element-5" />
          <Header data-id="element-6" />
          <main className="relative z-10" data-id="element-7">
            <Routes data-id="element-8">
              <Route path="/" element={<Home data-id="element-10" />} data-id="element-9" />
              <Route path="/about" element={<About data-id="element-12" />} data-id="element-11" />
              <Route path="/philosophy" element={<Philosophy data-id="element-14" />} data-id="element-13" />
              <Route path="/solutions" element={<Solutions data-id="element-16" />} data-id="element-15" />
              <Route path="/technology" element={<TechnologyApproach data-id="element-18" />} data-id="element-17" />
              <Route path="/ethics" element={<EthicsGovernance data-id="element-20" />} data-id="element-19" />
              <Route path="/insights" element={<Insights data-id="element-22" />} data-id="element-21" />
              <Route path="/contact" element={<Contact data-id="element-24" />} data-id="element-23" />
              <Route path="/privacy" element={<Privacy data-id="element-26" />} data-id="element-25" />
            </Routes>
          </main>
          <Footer data-id="element-27" />
          <CookieConsent data-id="element-28" />
        </div>
      </LanguageProvider>
    </Router>;
}